import { render, staticRenderFns } from "./ExchangeBidTile2.vue?vue&type=template&id=41351071&scoped=true&lang=pug&"
import script from "./ExchangeBidTile2.vue?vue&type=script&lang=js&"
export * from "./ExchangeBidTile2.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeBidTile2.vue?vue&type=style&index=0&id=41351071&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41351071",
  null
  
)

export default component.exports